var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83335 17.3332H14.1667M5.00002 2.2915H15V9.4165C15 12.0399 12.7614 14.1665 10 14.1665C7.23859 14.1665 5.00002 12.0399 5.00002 9.4165V2.2915Z",
    stroke: "#FFB800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1665V17.3332",
    stroke: "#FFB800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00002 4.6665V9.4165H4.16669C2.78598 9.4165 1.66669 8.35318 1.66669 7.0415C1.66669 5.72983 2.78598 4.6665 4.16669 4.6665H5.00002ZM15 9.4165V4.6665H15.8334C17.2141 4.6665 18.3334 5.72983 18.3334 7.0415C18.3334 8.35318 17.2141 9.4165 15.8334 9.4165H15Z",
    stroke: "#FFB800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "white",
    transform: "translate(1.52588e-05 0.708252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.2e859dd9fc7c8aead64790b2a4473e22.svg";
export { ForwardRef as ReactComponent };